import moment from 'moment'
import audioBg from '@/assets/images/audio.png'
import { MATERIAL_SIZES } from '@/views/create/gdt/model/creative-const.js'

function getMediaStateFields(row) {
  return {
    createMediaCostPlan: row.createMediaCostPlan,
    createMediaPlan: row.createMediaPlan

  }
}

function formatCreateTime(row) {
  return row.createTime ? moment(row.createTime).format('YYYY-MM-DD HH:mm:ss') : null
}
const video = (row) => {
  return {
    ...getMediaStateFields(row),
    type: 'video',
    id: row.id,
    imageId: row.imageId,
    name: row.name,
    cover_id: row.coverId,
    width: row.width,
    height: row.height,
    // 视频的封面图默认作为视频的预览图
    preview_url: row.cover_url,
    // 封面图使用替换后的图片封面或者视频封面图
    cover_url: row.replaced_cover_url || row.cover_url,
    url: row.source_url,
    cover_width: row.cover_width,
    cover_height: row.cover_height,
    cover_size: row.cover_size,
    size: row.size,
    description: row.name,
    signature: '',
    system_status: '',
    isFavor: row.isFavor,
    duration: row.duration,
    ruleId: row.ruleId,
    popularAnalysis: row.popularAnalysis,
    extractSlices: row.extractSlices,
    created_time: formatCreateTime(row)
  }
}

const poster = (row) => {
  return {
    type: 'poster',
    id: row.id,
    name: row.imageName,
    width: row.width,
    height: row.height,
    size: row.size,
    signature: row.md5,
    preview_url: row.url,
    url: row.url,
    created_time: formatCreateTime(row)
  }
}

const image = (row) => {
  return {
    ...getMediaStateFields(row),
    type: 'image',
    id: row.id,
    name: row.name,
    width: row.width,
    height: row.height,
    size: row.size,
    signature: '',
    preview_url: row.source_url,
    url: row.source_url,
    isFavor: row.isFavor,
    created_time: formatCreateTime(row),
    ruleId: row.ruleId
  }
}

const group_image = (row) => {
  return {
    ...getMediaStateFields(row),
    ...image(row),
    type: 'image_list',
    preview_url: row.overview_addr,
    url: row.overview_addr,
    image_list_urls: row.source_url.split(',')
  }
}

const fav = (row) => {
  const { imageType } = row

  if (imageType === 1) {
    return image(row)
  }
  if (imageType === 2) {
    return video(row)
  }
  if (imageType === 8) {
    return group_image(row)
  }
  return {}
}

const logo = (row) => {
  return {
    type: 'logo',
    id: row.id,
    name: row.name,
    width: row.width,
    height: row.height,
    size: row.size,
    signature: '',
    preview_url: row.source_url,
    url: row.source_url,
    created_time: formatCreateTime(row)
  }
}

const sticker = (row) => {
  return {
    ...logo(row),
    type: 'sticker'
  }
}

const audio = (row) => {
  return {
    type: 'audio',
    id: row.id,
    name: row.name,
    size: row.size,
    signature: '',
    preview_url: audioBg,
    url: row.source_url,
    source_file_type: row.source_file_type,
    created_time: 0,
    duration: row.duration
  }
}

const externalVideo = (material) => {
  const cover = material.cover || {}
  return {
    type: 'video',
    external: true,
    // 腾讯广告3.0单条修改创意页面，替换封面时需要用到
    // src/views/create/gdt/v3/components/creative/component-based-creative/index.vue
    inner_video_id: material.inner_id,
    id: material.inner_id,
    name: material.video_name || material.description,
    width: material.width,
    height: material.height,
    size: material.file_size,
    signature: material.signature,
    preview_url: material.key_frame_image_url || cover.preview_url,
    cover_url: cover.preview_url || material.key_frame_image_url,
    url: material.preview_url,

    cover_id: cover.image_id,
    cover_width: cover.width,
    cover_height: cover.height,
    cover_size: cover.file_size,
    description: material.description,
    duration: material.image_duration_millisecond ? material.image_duration_millisecond / 1000 : undefined,
    created_time: material.created_time
  }
}
const externalImage = (material) => {
  return {
    type: 'image',
    id: material.inner_id,
    external: true,
    name: material.image_name || material.description,
    width: material.width,
    height: material.height,
    size: material.file_size,
    signature: material.signature,
    preview_url: material.preview_url,
    url: material.preview_url,
    created_time: material.created_time
  }
}

const externalGroupImage = (material) => {
  return {
    ...externalImage(material),
    type: 'image_list'
  }
}

// 天工素材库转换素材结构
export const dataFormatter = { video, poster, image, sticker, group_image, logo, audio, fav }
// 媒体外部素材转换素材结构
export const externalDataFormatter = { video: externalVideo, image: externalImage, group_image: externalGroupImage }

/**
 * @description: 生产默认的选择框表单参数
 * @return {*}
 */
export const makeSelectorForm = () => {
  return {
    keyword: '',
    game_id: '',
    game_group_id: '',
    up_op_id: '',
    media_id: '',
    toutiaoLabel: [], // 头条筛选
    toutiaoLabelExclude: [], // 头条过滤
    // size: MATERIAL_SIZES.SIZE_1280_720, // 单选下拉素材尺寸
    size: '', // 单选下拉素材尺寸
    sizes: [], // 多选下拉素材尺寸
    amountType: [],
    planType: [],
    imageStyleList: [],
    uploadDateRange: []
  }
}
